import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

import { UIState } from '@/model/global/types';
import { makeSelectConfirmationState } from '@/model/identification/selectors';
import { IdentificationUIState } from '@/model/identification/types';

const selectConfirmationState = makeSelectConfirmationState();

const withIdentificationStatusGuard = (Component: React.FunctionComponent) => (
  props: { [k in string]: unknown },
): JSX.Element => {
  const confirmation = useSelector(selectConfirmationState);
  const location = useLocation();
  if (!location.pathname.startsWith(`/${UIState.IDENTIFICATION}`)) {
    return <Redirect to={`/${UIState.IDENTIFICATION}`} />;
  }
  if (
    // prettier: FIXME: https://github.com/prettier/prettier/pull/7111
    // prettier-ignore
    location.pathname.startsWith(`/${UIState.IDENTIFICATION}/${IdentificationUIState.CONFIRMATION}`)
    && !confirmation
  ) {
    return <Redirect to={`/${UIState.IDENTIFICATION}`} />;
  }
  return <Component {...props} />;
};

export default withIdentificationStatusGuard;
